import {
  Award, Truck, Route, Warehouse, Boxes, Package, BarChart3, Cpu, ShieldCheck, ClipboardCheck, Workflow, BookOpen,
  Users, Globe, Factory, Ship, Plane, Container, Gauge, Recycle, Wrench, Lightbulb, Briefcase, Target, Layers,
  Database, Settings, HeartHandshake, type LucideIcon,
} from 'lucide-react'

// แปลงคีย์ไอคอนจาก API → ไอคอน lucide — คีย์ต้องตรงกับ ICON_KEYS ฝั่ง API (skill_service.py)
// และชุดไอคอนใน backoffice (modules/Course/skillIcons.ts) · เพิ่มไอคอนใหม่ = เพิ่มทั้ง 3 ที่
export const SKILL_ICON_MAP: Record<string, LucideIcon> = {
  award: Award, truck: Truck, route: Route, warehouse: Warehouse, boxes: Boxes, package: Package,
  'bar-chart': BarChart3, cpu: Cpu, 'shield-check': ShieldCheck, 'clipboard-check': ClipboardCheck,
  workflow: Workflow, 'book-open': BookOpen, users: Users, globe: Globe, factory: Factory, ship: Ship,
  plane: Plane, container: Container, gauge: Gauge, recycle: Recycle, wrench: Wrench, lightbulb: Lightbulb,
  briefcase: Briefcase, target: Target, layers: Layers, database: Database, settings: Settings,
  'heart-handshake': HeartHandshake,
}

export const getSkillIcon = (key: string | null | undefined): LucideIcon => SKILL_ICON_MAP[key ?? ''] ?? Award

// สีเหรียญประจำหมวด — API ไม่มีสี จึงวนใช้ชุดสีนี้ตามลำดับหมวด
export const CATEGORY_PALETTE: { from: string; to: string }[] = [
  { from: '#6C63FF', to: '#8B5CF6' },
  { from: '#4DA3FF', to: '#6C63FF' },
  { from: '#06b6d4', to: '#4DA3FF' },
  { from: '#C026D3', to: '#8B5CF6' },
]
